<template>
  <div class="iv-layout">
    <div class="warning-bar" :class="branch">Helix - v{{ version }} {{ branch }}</div>

    <i-menu mode="horizontal" theme="light" active-name="1" @on-select="select" v-show="isLoggedIn">
      <div class="iv-layout-nav">
        <div style="margin:12px 48px 12px 12px; float:left;">
          <img
            src="http://www.internal-displacement.org/sites/default/files/logo_0.png"
            alt="IDMC Helix database"
            style="height:32px; height:32px;"
          >
        </div>
        <i-submenu name="2">
          <a
            class="ivu-menu-item"
            href="https://docs.google.com/spreadsheets/d/1ns2tArADx05MLiZru2KDAa_qI7pydcSWFLh2ZsQH_qM/edit#gid=0"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i aria-hidden="true" class="fa fa-file-excel-o"></i> Parking lot
          </a>

          <span slot="title">
            <Icon type="ios-analytics"></Icon>Monitoring
          </span>

          <i-menuitem name="/events">
            <FFIcon type="newspaper-o"></FFIcon>Events
          </i-menuitem>

          <i-menuitem name="/tabular-datasets">
            <FFIcon type="table"/>Tabular Datasets
          </i-menuitem>

          <i-menuitem name="/documents">
            <FFIcon type="file"/>Documents
          </i-menuitem>

          <i-menuitem name="/facts">
            <FFIcon type="folder-open"/>Facts
          </i-menuitem>

          <i-menuitem name="/publishers">
            <FFIcon type="graduation-cap"/>Publishers
          </i-menuitem>

          <i-menuitem name="/contacts">
            <FFIcon type="address-book"/>Contacts
          </i-menuitem>

          <i-menuitem name="/communications">
            <FFIcon type="phone"/>Communications
          </i-menuitem>

          <i-menuitem name="/countries/profiles/AFG">
            <FFIcon type="globe"/>Countries
          </i-menuitem>

          <i-menuitem name="/portfolios">
            <FFIcon type="users"/>Portfolios
          </i-menuitem>
        </i-submenu>

        <i-submenu name="dashboards">
          <span slot="title">
            <FFIcon type="tachometer"/>Dashboards
          </span>

          <i-menuitem name="/dashboards/performance" v-if="$can('view', 'performance_dashboard')">
            <FFIcon type="line-chart"/>Performance Dashboard
          </i-menuitem>
          <i-menuitem name="/dashboards/qa">
            <FFIcon type="bar-chart"/>QA Dashboard
          </i-menuitem>
        </i-submenu>

        <!--
          <i-submenu name="monitoring_platform">
            <span slot="title">
              <i class="icon8 icons8-binoculars"></i> Monitoring Platform</span>

            <i-menuitem name="/monitoring_platform/idetect">
            <i class="icon8 icons8-neural-network"></i> iDetect </i-menuitem>

            <i-menuitem name="/monitoring_platform/hazard_monitoring">
            <i class="icon8 icons8-wind-gauge"></i> Hazard Monitoring </i-menuitem>

            <i-menuitem name="/monitoring_platform/idus">
            <FFIcon type="newspaper" /> IDUs </i-menuitem>
          </i-submenu>
        -->
        <a
          class="ivu-menu-item"
          href="https://github.com/idmc-labs/idmc-database-feedback/issues"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i aria-hidden="true" class="fa fa-github"></i> GitHub
        </a>

        <i-submenu name="user" v-if="isLoggedIn">
          <span slot="title">
            <Icon type="ios-user"></Icon>
            {{ currentUser.name }}
          </span>
          <i-menuitem name="/change_password" v-if="$can('update', 'password')">
            <FFIcon type="key"/>Change Password
          </i-menuitem>
          <i-menuitem name="signout">
            <FFIcon type="sign-out"/>Logout
          </i-menuitem>
        </i-submenu>
      </div>
    </i-menu>

    <div class="iv-layout-content">
      <!-- <i-row type="flex"> -->
      <!-- <i-col span="24"> -->
      <router-view :key="$route.fullPath"></router-view>
      <Back-top></Back-top>
      <!-- </i-col> -->
      <!-- </i-row> -->
    </div>

    <div class="iv-layout-footer">IDMC Helix - v{{ version }} {{ branch }}</div>
  </div>
</template>

<script>
import { MenuItem, Submenu } from "iview";

export default {
  components: {
    "i-menuitem": MenuItem,
    "i-submenu": Submenu,
  },
  data() {
    return {
      version: process.env.VERSION,
    };
  },
  computed: {
    branch() {
      switch (document.location.hostname) {
        case "testing.idmcdb.org":
          return "testing";
        case "development.idmcdb.org":
          return "development";
        case "dev.idmcdb.org":
          return "development";
        case "localhost":
          return "localhost";
        default:
          return "production";
      }
    },
  },
  methods: {
    select(action) {
      switch (action) {
        case "signout":
          this.signout();
          break;
        default:
          this.$router.push(action);
      }
    },
    signout() {
      this.logout().then(() => {
        this.$router.push("/signin");
      });
    },
  },
};
</script>

<style>
.iv-layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
}

.iv-layout-nav {
  width: 100%;
  margin: 0 auto;
}

.iv-layout-breadcrumb {
  padding: 10px 15px 0;
}

.iv-layout-content {
  min-height: calc(100vh - 80px);
  margin: 15px;
  overflow: visible;
  background: #fff;
  border-radius: 4px;
  padding: 24px 48px;
}

.iv-layout-content-main {
  padding: 10px;
}

.iv-layout-footer {
  text-align: center;
  padding: 10px 0 20px;
  color: #9ea7b4;
}
/* Custom form */

.ivu-tabs {
  overflow: visible;
}

.ivu-form.ivu-form-label-right .ivu-form-item-label {
  font-weight: 500;
  padding: 12px 6px 6px 0px !important;
  margin: 0px !important;
}

.ivu-form .ivu-form-item-label {
  font-weight: 500;
  padding: 3px 0 !important;
  margin: 0 !important;
}

.ivu-form-item {
  margin-bottom: 9px !important;
}

.ivu-card {
  margin-bottom: 9px;
}

.ivu-col .ivu-col-span-12 .ivu-card {
  margin-right: 9px;
}

.ivu-col .ivu-col-span-12:last-child .ivu-card {
  margin-right: 0px;
}

.ivu-card-head p {
  font-weight: 500;
  color: #5c738e;
}

.ivu-col .ivu-col-span-12 .ivu-card {
  margin-right: 9px;
}

.warning-bar {
  height: 18px;
  width: 100%;
  color: white;
  font-weight: bold;
  text-align: center;
}

.warning-bar.localhost {
  background-color: cornflowerblue;
}

.warning-bar.testing {
  background-color: firebrick;
}

.warning-bar.development {
  background-color: firebrick;
}

.warning-bar.production {
  display: none;
}
.action-buttons button.ivu-btn {
  margin-right: 3px;
}

.ivu-tabs {
  overflow: visible;
}

pre {
  outline: 1px solid orange;
  background-color: lightgrey;
  padding: 9px;
}

.theme--light.application {
  background-color: #fff;
}
</style>
